import { PATIENT_KEY, USER_KEY } from "./constants";

export const getStoredFilters = (key: string): Record<string, string> => {
    const storedFilters = localStorage.getItem(key);
    return storedFilters ? JSON.parse(storedFilters) : {};
};

export const updateStoredFilters = (newFilters: Record<string, string>, key: string): void => {
    const storedFilters = getStoredFilters(key);
    const updatedFilters = { ...storedFilters, ...newFilters };
    localStorage.setItem(key, JSON.stringify(updatedFilters));
};

export const getSearchParam = (filters: Record<string, string>, key: string): string => {
    updateStoredFilters(filters, key);
    const storedFilters = getStoredFilters(key);
    const queryParams = new URLSearchParams(storedFilters);
    return queryParams.toString();
};

export const dropFilters = () => {
    localStorage.removeItem(PATIENT_KEY);
    localStorage.removeItem(USER_KEY);
};